import {
	START_DATE_TYPE,
	UPDATED,
	CREATED,
	DUE_DATE_TYPE,
	DATE_CF_TYPE,
} from '@atlassian/jira-platform-field-config';
import type { StringValue } from '../../../value/types';
import type { SUPPORTED_DATE_TYPES } from '../types';

const getDateValue: StringValue<{
	fieldId: string;
	type: SUPPORTED_DATE_TYPES;
	value: string | null;
}> = (field) => field.value || '';

export const dateStringValueHandler = {
	[START_DATE_TYPE]: getDateValue,
	[UPDATED]: getDateValue,
	[CREATED]: getDateValue,
	[DUE_DATE_TYPE]: getDateValue,
	[DATE_CF_TYPE]: getDateValue,
};
